import { ScriptEnvironment } from 'app/components/scripts/helpers';
import Script from 'app/utils/lib/script';

/* eslint-disable @typescript-eslint/naming-convention */
const PENDO_SCRIPT_CONTENT = `
(function(apiKey) {
  (function(p, e, n, d, o) {
    var v, w, x, y, z;o = p[d] = p[d] || {};o._q = o._q || [];
    v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track'];for (w = 0, x = v.length;w < x;++w) {
      (function(m) {
        o[m] = o[m] || function() {
          o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)));
        };
      })(v[w]);
    }
    y = e.createElement(n);y.async = !0;y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
    z = e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y, z);
  })(window, document, 'script', 'pendo');
})('a637176e-87a5-4716-4dfc-c90b123ef9f3');
`;
/* eslint-enable @typescript-eslint/naming-convention */

export const PendoScript = () => {
  return (
    <Script
      // eslint-disable-next-line @typescript-eslint/naming-convention
      dangerouslySetInnerHTML={{ __html: PENDO_SCRIPT_CONTENT }}
      environment={ScriptEnvironment.ProductionOnly}
      id="pendo"
      serviceName="Pendo"
      strategy="beforeInteractive"
    />
  );
};

export default PendoScript;
